<script>
  import HighCharts from 'highcharts'
  // import {DarkTheme} from '../../../_default/utils/HighchartsTheme'
  // Apply the theme
  // HighCharts.setOptions(DarkTheme)
  HighCharts.setOptions({
    lang: {
      loading: 'Aguarde...',
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      exportButtonTitle: 'Exportar',
      printButtonTitle: 'Imprimir',
      rangeSelectorFrom: 'De',
      rangeSelectorTo: 'Até',
      rangeSelectorZoom: 'Periodo',
      downloadPNG: 'Download imagem PNG',
      downloadJPEG: 'Download imagem JPEG',
      downloadPDF: 'Download documento PDF',
      downloadSVG: 'Download imagem SVG'
      // resetZoom: "Reset",
      // resetZoomTitle: "Reset,
      // thousandsSep: ".",
      // decimalPoint: ','
    }
  })
  export default{
    name: 'grafico-leilao-dash',
    data () {
      return {
        active: true,
        options: {

          chart: {
            height: 200,
            type: 'line'
          },

          title: {
            text: null
          },

          subtitle: {
            text: 'Fonte: wtis-bi / LOG DEP Mobilidade Urbana data',
            align: 'left'
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              month: '%b'
            }
          },
          yAxis: {
            title: {
              text: 'Acessos'
            },
            labels: {
              formatter: function () {
                return this.value
              }
            }
          },
          tooltip: {
//            headerFormat: '<b>{series.name}</b><br/>',
            pointFormat: '{point.y} de acessos'
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },

          plotOptions: {
            series: {
              label: {
                connectorAllowed: false
              }/* ,
              pointStart: 2010 */
            }
          },

          series: [{
            name: 'Acessos ao Leilão',
            data: [10, 30, 50, 120, 213, 202, 348, 399],
            pointInterval: 24 * 3600 * 1000 * 1 // 1 dias
          }],

          responsive: {
            rules: [{
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
                }
              }
            }]
          }

        }
      }
    },
    computed: {
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      activate () {
        this.active = true
      },
      deactivate () {
        this.active = false
      }
    },
    components: {}
  }
</script>

<template>
  <div class="bg-black dker"> <!-- panel hbox hbox-auto-xs no-border -->
    <div class="col wrapper">
      <label class="i-switch bg-info pull-right">
        <input type="checkbox" aria-invalid="false" v-model="active">
        <i></i>
      </label>
      <div>
      <h4 class="font-thin m-t-none m-b-none text-white ">Histórico de Acessos</h4>
      <span class="m-b block text-sm text-muted  text-white">Resumo de acessos ao leilão</span>
      <highcharts v-if="active" :options="options"></highcharts>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// GraficoLeilao.vue?4253b056